<template>
	<div class="omapi-guides">
		<div class="omapi-omu__section-header">
			<h3>Guides</h3>
			<a
				:href="marketingUrl('university/guides', 'University')"
				target="_blank"
				rel="noopener"
				@click="maybeUpsell"
			>
				View All Guides ({{ totalGuides }})
			</a>
		</div>
		<div class="omapi-guides__grid omapi-omu__grid omapi-card__flex">
			<core-loading v-if="isLoading" />
			<university-guide v-for="guide in guides" :key="guide.id" :guide="guide" />
		</div>
	</div>
</template>

<script lang="js">
import { mapState } from 'vuex';
import { marketingSso } from '@/components/mixins/marketingSso';
import { upsell } from '@/university/mixins/upsell';

export default {
	mixins: [marketingSso, upsell],
	data() {
		return {
			utmMedium: 'UniversityGuide',
		};
	},
	computed: {
		...mapState('omu', ['guides', 'totalGuides']),
		isLoading() {
			return this.$store.getters.isFetching('guides');
		},
	},
};
</script>
